export var REPLAY_PLAY_POSITION = 'REPLAY_PLAY_POSITION';
export var REPLAY_START_RECORDING = 'REPLAY_START_RECORDING';
export var REPLAY_STOP_RECORDING = 'REPLAY_STOP_RECORDING';
export var REPLAY_START_PLAYING = 'REPLAY_START_PLAYING';
export var REPLAY_STOP_PLAYING = 'REPLAY_STOP_PLAYING';
export var REPLAY_SKIP_PLAYING = 'REPLAY_SKIP_PLAYING';
export var REPLAY_SET_CURSOR_POSITION = 'REPLAY_SET_CURSOR_POSITION';
export var REPLAY_CLICK_START = 'REPLAY_CLICK_START';
export var REPLAY_CLICK_END = 'REPLAY_CLICK_END';
export var REPLAY_SEEK = 'REPLAY_SEEK';
export var REPLAY_SET_CURRENT_EVENT = 'REPLAY_SET_CURRENT_EVENT';
export var REPLAY_ENDED = 'REPLAY_ENDED';
export var REPLAY_PAUSED = 'REPLAY_PAUSED';
export var REPLAY_PROGRESS = 'REPLAY_PROGRESS';
export var REPLAY_ON_EVENT = 'REPLAY_ON_EVENT';
